const PINNED_START_KEYS = ['checkbox']
const PINNED_END_KEYS = ['actions']

export function isPinnedColumnKey(key) {
    return PINNED_START_KEYS.includes(key) || PINNED_END_KEYS.includes(key)
}

export function normalizeColumnOrder(fields) {
    if (!fields || !fields.length) {
        return fields
    }

    const startPinned = fields.filter(f => PINNED_START_KEYS.includes(f.key))
    const endPinned = fields.filter(f => PINNED_END_KEYS.includes(f.key))
    const middle = fields.filter(f => !isPinnedColumnKey(f.key))

    return [...startPinned, ...middle, ...endPinned]
}

export function mergeColSaves(canonicalFields, savedArray) {
    if (!savedArray || !savedArray.length) {
        return null
    }

    const canonicalByKey = {}
    canonicalFields.forEach(field => {
        canonicalByKey[field.key] = field
    })

    const savedKeys = new Set()
    const merged = []

    savedArray.forEach(saved => {
        const canonical = canonicalByKey[saved.key]
        if (!canonical) {
            return
        }

        savedKeys.add(saved.key)
        merged.push({
            ...canonical,
            key: saved.key,
            label: saved.label != null ? saved.label : canonical.label,
            visible: saved.visible != null ? parseInt(saved.visible) : (canonical.visible != null ? parseInt(canonical.visible) : 1)
        })
    })

    canonicalFields.forEach(field => {
        if (!savedKeys.has(field.key)) {
            merged.push({
                ...field,
                visible: field.visible != null ? parseInt(field.visible) : 1
            })
        }
    })

    return normalizeColumnOrder(merged)
}

export function buildVisibleFields(canonicalFields, userFields) {
    if (!userFields || !userFields.length) {
        return canonicalFields
    }

    const canonicalByKey = {}
    canonicalFields.forEach(field => {
        canonicalByKey[field.key] = field
    })

    const visible = userFields
        .filter(uf => parseInt(uf.visible) === 1)
        .map(uf => {
            const canonical = canonicalByKey[uf.key]
            if (!canonical) {
                return null
            }

            return { ...canonical, ...uf, visible: parseInt(uf.visible) }
        })
        .filter(Boolean)

    return visible.length ? visible : canonicalFields
}

export function formatColSavesPayload(fields) {
    return normalizeColumnOrder(fields).map(e => ({
        key: e.key,
        visible: parseInt(e.visible),
        label: e.label
    }))
}

/** Prefer saved prefs when present; empty [] is truthy in JS so must check length. */
export function cloneFieldsForAdjust(userFields, canonicalFields) {
    const source = (userFields && userFields.length) ? userFields : canonicalFields
    return JSON.parse(JSON.stringify(source))
}

export default {
    methods: {
        isPinnedColumnKey,
        normalizeColumnOrder,
        mergeColSaves,
        buildVisibleFields,
        formatColSavesPayload,
        cloneFieldsForAdjust
    }
}
